import { FeedbotMiddleware, isThunk } from '../types'
import { actions as ssmlActions } from '../../store/ssml'
import { areFeatureValuesReadySelector, featureValueSelector } from '../features/selectors'
import { DISCARD_CHANGES } from '../../constants/actionTypes'
import { isTelephonySelector } from '../flow/selectors/selectors'

export const ssmlMiddleware: FeedbotMiddleware =
  ({ dispatch, getState }) =>
  next =>
  action => {
    if (isThunk(action)) {
      return next(action)
    }

    if (!areFeatureValuesReadySelector(getState())) {
      return next(action)
    }

    const state = getState()
    const isTelephony = isTelephonySelector(state)
    const isSsmlValidationEnabled = featureValueSelector('SSML_VALIDATION')(state)

    if (!isTelephony || !isSsmlValidationEnabled) {
      return next(action)
    }

    if (action.type === DISCARD_CHANGES) {
      dispatch(ssmlActions.clearSsmlValidationResults())
    }

    return next(action)
  }
